// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"styles_sectionHeader__4Y2qi"};